<!-- 
Users Authentication Logs listing page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="Authentication Logs"
      user-guide-topic="administration-authentication-logs"
    />
    <our-search-bar>
      <our-quick-search 
        slot="quick-search"
        :criteria-mutation="criteriaMutation" 
        :value="criteria.emailAddress"
        label="User email" 
        field="userEmail" 
        @changed="$refs.listing.refresh()"
      />
      <our-search-button 
        slot="search-button"
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search authentication logs"
        show-all
        @changed="$refs.listing.refresh()"
      />
      <our-saved-searches-menu
        slot="saved-searches-button"
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="authenticationLogs" 
        @selected="$refs.listing.refresh()"
      />
    </our-search-bar>
    <authentication-log-listing ref="listing"/>
  </div>
</template>

<script>
import AuthenticationLogListing from "@/components/authentication-logs/AuthenticationLogListing.vue";
import * as mutation from "@/store/authentication-logs/mutation-types";
import { getSearchFilters } from "@/store/authentication-logs/helpers";

export default {
  name: "AuthenticationLogs",
  components: { AuthenticationLogListing },
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA,
      breadcrumbs: [{ text: "Authentication Logs" }]
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters();
    },
    criteria() {
      return this.$store.state.authenticationLogs.listing.criteria;
    }
  }
};
</script>
